import React, { useContext } from 'react';
import { observer } from 'mobx-react-lite';
import { UiContext } from 'shared/lib/contexts/uiContext';
import { useGetSpacing } from 'shared/hooks/useGetSpacing';
import { useTypographyFonts } from 'shared/hooks/useGetTypographyFonts';
import { useCurrentBreakpoint } from 'shared/hooks/useCurrentBreakpoint';
import { SnackbarProvider } from 'notistack';
import Snackbar from 'shared/lib/components/snackbar/snackbar';
import { MobxContext } from 'shared/lib/contexts/mobxContext';

export default observer(function UiContextProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const { mobxStore } = useContext(MobxContext);
  const currentBp = useCurrentBreakpoint();
  const spacingPreset = useGetSpacing({ currentBp });
  const { getFontSize } = useTypographyFonts({ currentBp });

  return (
    <UiContext.Provider
      value={{
        spacings: spacingPreset,
        getFontSize,
      }}
    >
      <SnackbarProvider maxSnack={5}>
        <>
          <Snackbar store={mobxStore.notificationsStore}></Snackbar>
          {children}
        </>
      </SnackbarProvider>
    </UiContext.Provider>
  );
});
